import React from 'react';
import {
  findNodePath,
  focusEditor,
  removeNodes,
  useEditorRef,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export const RemoveNodeButton = ({
  element,
  children,
  className,
  showIcon = true,
  ...props
}) => {
  const editor = useEditorRef();


  return (
    <button
      className={clsx(className, 'button--popover', 'button--unstyled')}
      onClick={() => {
        const path = findNodePath(editor, element);

        removeNodes(editor, { at: path });

        focusEditor(editor, editor.selection);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      {showIcon && (
        <FontAwesomeIcon icon={['fa', 'trash-alt']} />
      )}
      {children}
    </button>
  );
};
